import useSWR from "swr";
import { notify } from "../../../utils";
import { CargoSpectreScanner, ICorpStation } from "../../../globals/interfaces";
import { useState } from "react";
import apiClient from "../../../apiClient";
import useModal from "../../../customHooks/useModal";
import ActionIcon from "../../../components/custom/ActionIcon";
import VirtualTable from "../../../components/custom/VirtualTable";
import CargoSpectreModal from "./Modal";

interface ResData { scanners: Array<CargoSpectreScanner>, stations: Array<ICorpStation> }

const ENDPOINT = '/cargospectre-scanner';

const defaultReturn: ResData = {
    scanners: [],
    stations: []
}

const customFetcher = async (): Promise<ResData> => {
    try {
        const res = await apiClient.get(ENDPOINT);
        return res.data;
    } catch (err) {
        alert(err);
        return defaultReturn
    }
}

export default function CargoSpectreScanners() {
    const { data, mutate } = useSWR(ENDPOINT, customFetcher, {
        fallbackData: defaultReturn
    });
    const { scanners, stations } = data;

    const [id, setId] = useState<number>();
    const record = scanners.find(item => item.id === id);

    const createUpdateItem = async (data: CargoSpectreScanner, update?: boolean) => {
        try {
            const method = update ? 'put' : 'post';
            await apiClient[method](ENDPOINT, data);
            mutate();
            setModal(false);
            notify('Success');
        } catch (err) {
            alert(err);
        }
    }

    const deleteItem = async (id: number) => {
        try {
            await apiClient.delete(`${ENDPOINT}/${id}`);
            setModal(false);
            notify('Deleted');
            mutate();
        } catch (err) {
            alert(err);
        }
    }

    const { modal, setModal } = useModal();

    const handleLaunchModal = (id?: number) => {
        setId(id || undefined);
        setModal(true);
    }

    return (
        <div>
            <ActionIcon
                type={'add'}
                onClick={handleLaunchModal}
            />
            <VirtualTable<CargoSpectreScanner>
                data={scanners}
                mapping={[{
                    name: 'Name',
                    value: 'name'
                }, {
                    name: 'Unit',
                    value: 'unit'
                }, {
                    name: 'IP Address',
                    value: 'ipAddress'
                }, {
                    name: 'Last Calibrated',
                    value: 'lastCalibrated',
                    date: true,
                    utc: true
                }, {
                    name: 'Created by',
                    value: 'createdBy',
                    email: true
                }, {
                    name: 'Created',
                    value: 'created',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Modified by',
                    value: 'modifiedBy',
                    email: true
                }, {
                    name: 'Modified',
                    value: 'modified',
                    datetime: true,
                    utc: true
                }]}
                handleClick={item => handleLaunchModal(item.id)}
            />
            <CargoSpectreModal
                modal={modal}
                setModal={setModal}
                onSubmit={createUpdateItem}
                deleteItem={deleteItem}
                record={record}
                stations={stations}
            />
        </div>
    )
}